const config = {
  CLIENT_URL: process.env.REACT_APP_CLIENT_ENDPOINT,

  // SSOR: Agent-Proxy URL for direct WebSocket connection
  AGENT_PROXY_URL: process.env.REACT_APP_AGENT_PROXY_URL,

  // Feature flag for SSOR direct connection (gradual rollout)
  // Note: Keep as string for runtime replacement via entrypoint.sh
  USE_AGENT_PROXY: process.env.REACT_APP_USE_AGENT_PROXY,

  // // LOCAL - Use relative URLs to go through proxy
  // CLIENT_URL: "localhost:3000", // Client runs on port 3000

  AUTH_BACKEND: "Dummy",
  FIRE_BASE: {
    API_KEY: process.env.REACT_APP_APIKEY,
    AUTH_DOMAIN: process.env.REACT_APP_AUTHDOMAIN,
    DATABASEURL: process.env.REACT_APP_DATABASEURL,
    PROJECTID: process.env.REACT_APP_PROJECTID,
    STORAGEBUCKET: process.env.REACT_APP_STORAGEBUCKET,
    MESSAGINGSENDERID: process.env.REACT_APP_MESSAGINGSENDERID,
    APPID: process.env.REACT_APP_APPID,
    MEASUREMENTID: process.env.REACT_APP_MEASUREMENTID,
  },
  GOOGLE: {
    API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    SECRET: process.env.REACT_APP_GOOGLE_SECRET_KEY,
  },
  FACEBOOK: {
    APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID,
    CONFIG_ID: process.env.REACT_APP_FACEBOOK_CONFIG_ID,
  },
};

export default config;
